import { ReactNode } from "react";
import Link from "next/link";

const DrawerLink = ({
  link,
  children,
  color,
}: {
  link?: string;
  children: ReactNode;
  color?: string;
}) => {
  return (
    <Link
      href={link || "#"}
      style={{
        textDecoration: "none",
        color: color,
        fontWeight: 700,
      }}
    >
      {children}
    </Link>
  );
};

export default DrawerLink;
